import { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import TeamItem from './TeamItem';
import TeamSwiperItem from './TeamSwiperItem';

export default function TeamWrapper({ itemKey, teamMembers, allTeamMembers, first = false, showAllButton = true }) {
    return (
        <div className={`team-wrapper mx-sm-5 ${!first ? `mt-50 d-none d-sm-flex` : ''}`}>
            <div className="left" data-aos="fade-up" data-aos-delay={300} data-aos-duration={1000}>
                {first && (
                    <h2>
                        Kop koffie?
                        <a href="/contact" className="title-btn">
                            Je bent welkom
                        </a>
                    </h2>
                )}
            </div>
            <div className="right" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1000}>
                <div className="team-layout d-none d-sm-flex">
                    {teamMembers?.map((member, index) => (
                        <TeamItem key={member.id} teamMember={member} active={index === (itemKey % 2 === 0 ? 2 : 0)} />
                    ))}
                </div>
                {first && (
                    <div className="team-slider d-block d-sm-none">
                        <Swiper
                            spaceBetween={50}
                            slidesPerView={1}
                            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                            loop
                            autoplay={{ delay: 3000 }}
                            pagination={{ el: '.team-pagination', clickable: true, dynamicBullets: false }}
                            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        >
                            {allTeamMembers?.map((member) => (
                                <SwiperSlide key={member.id}>
                                    <TeamSwiperItem key={member.id} teamMember={member} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        {/* If we need pagination */}
                        <div className="swiper-pagination team-pagination" />
                    </div>
                )}
                {showAllButton && (
                    <div className="team-btn">
                        <a href="/medemerkers">Alle creatievelingen</a>
                    </div>
                )}
            </div>
        </div>
    );
}
